/*
  Tokyo Romance Club — Hero intro, gentle drift, and the glow sweep are
  pure CSS (see trc-motion.css) and need no JS. Every section that
  needed a scroll-reveal fade-up now owns its own dedicated motion
  JS/CSS (trc-*-motion.js/css: New Arrivals, Shop by Brand, Style
  Collections, About/Service & Trust, Shop by Price, Newsletter), so
  this file now only sets the shared html.trc-js marker (kept for any
  future section that wants to key off it) and tidies up the intro
  overlay element after load. Never runs at all inside the theme editor
  so block selection / image pickers are never affected.
*/
(function () {
  if (window.__trcMotionInit) return;
  window.__trcMotionInit = true;

  var designMode = document.documentElement.classList.contains('shopify-design-mode');
  if (designMode) return;

  document.documentElement.classList.add('trc-js');

  // Purely cosmetic tidy-up; the overlay's own CSS animation already
  // fades it out and it is pointer-events:none the whole time, so this
  // is not required for correctness.
  window.addEventListener('load', function () {
    var overlay = document.getElementById('trc-intro-overlay');
    if (!overlay) return;
    setTimeout(function () {
      if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
    }, 700);
  });
})();
